import { useState, useEffect } from 'react';

export const CountdownTimer = () => {
  const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });

  useEffect(() => {
    const calculateTimeToNextDraw = () => {
      const now = new Date();
      
      // Find next Monday at 12pm ET (aligned with backend schedule-draws)
      const targetDay = 1; // Monday
      const targetHour = 12; // 12pm ET
      
      // Create date in ET timezone
      const etOffset = -5; // EST (adjust for EDT if needed)
      const utcNow = now.getTime() + (now.getTimezoneOffset() * 60000);
      const etNow = new Date(utcNow + (etOffset * 3600000));
      
      const nextDraw = new Date(etNow);
      nextDraw.setHours(targetHour, 0, 0, 0);
      
      // Find next Monday
      const currentDay = etNow.getDay();
      const daysUntilMonday = currentDay === 0 ? 1 : (currentDay === 1 ? 0 : 8 - currentDay);
      
      if (daysUntilMonday === 0 && etNow.getHours() >= targetHour) {
        // It's Monday but past 12pm, go to next Monday
        nextDraw.setDate(nextDraw.getDate() + 7);
      } else {
        nextDraw.setDate(nextDraw.getDate() + daysUntilMonday);
      }
      
      // Convert back to local time for diff calculation
      const drawTimeUTC = nextDraw.getTime() - (etOffset * 3600000);
      const diff = drawTimeUTC - now.getTime();
      
      if (diff <= 0) {
        return { days: 0, hours: 0, minutes: 0, seconds: 0 };
      }
      
      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);
      
      return { days, hours, minutes, seconds };
    };

    setTimeLeft(calculateTimeToNextDraw());
    
    const interval = setInterval(() => {
      setTimeLeft(calculateTimeToNextDraw());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex items-center justify-center lg:justify-end gap-2">
      <TimeBlock value={timeLeft.days} label="d" />
      <span className="text-lg sm:text-2xl lg:text-3xl font-bold opacity-60">:</span>
      <TimeBlock value={timeLeft.hours} label="h" />
      <span className="text-lg sm:text-2xl lg:text-3xl font-bold opacity-60">:</span>
      <TimeBlock value={timeLeft.minutes} label="m" />
      <span className="text-lg sm:text-2xl lg:text-3xl font-bold opacity-60">:</span>
      <TimeBlock value={timeLeft.seconds} label="s" />
    </div>
  );
};

const TimeBlock = ({ value, label }: { value: number; label: string }) => (
  <div className="flex items-baseline gap-0.5">
    <span className="text-lg sm:text-2xl lg:text-3xl font-bold tabular-nums">
      {value.toString().padStart(2, '0')}
    </span>
    <span className="text-sm font-medium opacity-70">{label}</span>
  </div>
);
